import { RestClient } from '../RestClient/RestClient.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var PaywallFeature = /* @__PURE__ */ ((PaywallFeature2) => {
  PaywallFeature2["ChangePlan"] = "change_plan";
  PaywallFeature2["RestoreSubscription"] = "restore_subscription";
  PaywallFeature2["CancelSubscription"] = "cancel_subscription";
  PaywallFeature2["AddPaymentDetails"] = "add_payment_details";
  PaywallFeature2["EditPaymentDetails"] = "edit_payment_details";
  PaywallFeature2["PurchaseGifts"] = "purchase_gifts";
  PaywallFeature2["RedeemGifts"] = "redeem_gifts";
  return PaywallFeature2;
})(PaywallFeature || {});
var PaywallResult = /* @__PURE__ */ ((PaywallResult2) => {
  PaywallResult2["Aborted"] = "aborted";
  PaywallResult2["Payed"] = "payed";
  PaywallResult2["HasAccess"] = "has-access";
  return PaywallResult2;
})(PaywallResult || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["EUR"] = "EUR";
  Currency2["USD"] = "USD";
  Currency2["SEK"] = "SEK";
  Currency2["GBP"] = "GBP";
  Currency2["UNKNOWN"] = "UNKNOWN";
  return Currency2;
})(Currency || {});
var DurationUnit = /* @__PURE__ */ ((DurationUnit2) => {
  DurationUnit2["Minute"] = "Minute";
  DurationUnit2["Hour"] = "Hour";
  DurationUnit2["Day"] = "Day";
  DurationUnit2["Week"] = "Week";
  DurationUnit2["Month"] = "Month";
  DurationUnit2["Year"] = "Year";
  DurationUnit2["Forever"] = "Forever";
  DurationUnit2["Season"] = "Season";
  DurationUnit2["Unknown"] = "Unknown";
  return DurationUnit2;
})(DurationUnit || {});
var SubscriptionStatus = /* @__PURE__ */ ((SubscriptionStatus2) => {
  SubscriptionStatus2["Active"] = "active";
  SubscriptionStatus2["Canceled"] = "canceled";
  SubscriptionStatus2["PendingActivation"] = "pending_activation";
  SubscriptionStatus2["PendingCancellation"] = "pending_cancellation";
  SubscriptionStatus2["TimeLimited"] = "time_limited";
  SubscriptionStatus2["Unknown"] = "unknown";
  return SubscriptionStatus2;
})(SubscriptionStatus || {});
var PaymentMethodTypes = /* @__PURE__ */ ((PaymentMethodTypes2) => {
  PaymentMethodTypes2["CreditCard"] = "creditCard";
  PaymentMethodTypes2["Paypal"] = "paypal";
  PaymentMethodTypes2["Unknown"] = "unknown";
  return PaymentMethodTypes2;
})(PaymentMethodTypes || {});
var PaymentDropInClassNames = /* @__PURE__ */ ((PaymentDropInClassNames2) => {
  PaymentDropInClassNames2["Container"] = "paywall-drop-in-container";
  PaymentDropInClassNames2["Spinner"] = "paywall-drop-in-spinner";
  return PaymentDropInClassNames2;
})(PaymentDropInClassNames || {});
var PaymentEvents = /* @__PURE__ */ ((PaymentEvents2) => {
  PaymentEvents2["DropInSubmitStart"] = "paywall-drop-in-submit-start";
  return PaymentEvents2;
})(PaymentEvents || {});
var CompletePurchaseStatus = /* @__PURE__ */ ((CompletePurchaseStatus2) => {
  CompletePurchaseStatus2["Completed"] = "completed";
  CompletePurchaseStatus2["Failed"] = "failed";
  CompletePurchaseStatus2["Cancelled"] = "cancelled";
  CompletePurchaseStatus2["Unknown"] = "unknown";
  return CompletePurchaseStatus2;
})(CompletePurchaseStatus || {});
const filterPurchasablePlans = (plans, purchasablePlanIds) => {
  if (!(purchasablePlanIds == null ? void 0 : purchasablePlanIds.length)) {
    return [];
  }
  return plans.filter(({ id }) => purchasablePlanIds.includes(`${id}`));
};
const createIntegrationApi = (integrationEndpoint) => {
  const restClient = new RestClient({
    baseUrl: window.location.origin + integrationEndpoint
  });
  const commonParams = urlWithParams();
  const getSession = (path, config) => restClient.request(__spreadValues({
    path: path != null ? path : "/token-attributes",
    params: __spreadValues(__spreadValues({}, commonParams), config == null ? void 0 : config.params)
  }, config));
  return {
    getSession: createSessionCache(getSession),
    fetch: (path, config) => restClient.request(__spreadValues({
      path,
      params: __spreadValues(__spreadValues({}, commonParams), config == null ? void 0 : config.params)
    }, config))
  };
};
const SESSION_CACHE_MS = 2e4;
const createSessionCache = (getSession) => {
  let sessionPromise;
  let expiryTimestamp = +new Date() + SESSION_CACHE_MS;
  return (path, config) => {
    const expiresInMs = expiryTimestamp - +new Date();
    if (sessionPromise === void 0 || expiresInMs <= 0) {
      sessionPromise = getSession(path, config);
      expiryTimestamp = +new Date() + SESSION_CACHE_MS;
    }
    return sessionPromise;
  };
};
const urlWithParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramsToForward = [
    "orgHash",
    "variationHash",
    "appId",
    "uiVersion",
    "env",
    "countryCode",
    "regionCode"
  ];
  return paramsToForward.reduce((acc, p) => {
    if (urlParams.has(p)) {
      acc[p] = urlParams.get(p) || "";
    }
    return acc;
  }, {});
};

export { CompletePurchaseStatus, Currency, DurationUnit, PaymentDropInClassNames, PaymentEvents, PaymentMethodTypes, PaywallFeature, PaywallResult, SESSION_CACHE_MS, SubscriptionStatus, createIntegrationApi, createSessionCache, filterPurchasablePlans, urlWithParams };
